<script setup lang="ts">
import type { PropertySeoLinks } from '@@/shared/property/seo-link';

defineProps<{
  seoLinks: PropertySeoLinks
}>();
</script>

<template>
  <div class="grid md:grid-cols-2 lg:grid-cols-4">
    <PropertySeoSection
      v-for="(seoSection, index) of seoLinks"
      :key="index"
      class="pr-l"
      :seo-section
    />
  </div>
</template>
